import React from "react";
import Spinner from "design-system/src/Foundation/Spinner/Spinner";

const overlayStyle: React.CSSProperties = {
  position: "fixed",
  inset: 0,
  zIndex: 55,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "rgba(0, 0, 0, 0.3)",
};

/**
 * Overlay plein écran pendant l'ouverture / chargement de ProductModal.
 */
const ProductModalLoadingOverlay = () => (
  <div
    role="status"
    aria-busy="true"
    aria-live="polite"
    style={overlayStyle}
  >
    <Spinner absolute srText="Chargement du produit..." />
  </div>
);

export default ProductModalLoadingOverlay;
